/**
 * digitt: DENG-7340 — "Undo send" window (Frontapp parity).
 *
 * Holds an outgoing send for a short window so the operator can cancel it before it
 * actually leaves, mirroring Frontapp. Pure and framework-free so it can be unit-tested
 * with fake timers. Owned by Digitt — not part of upstream Chatwoot.
 */

export const UNDO_SEND_DELAY = 8_000;

/**
 * Schedules `send` to run after `delay` ms unless `undo()` is called first, driven by a
 * SINGLE 1s interval that both counts down and fires the send at zero — `onTick(secondsLeft)`
 * is the only source of truth for the countdown (no second timer). `send` runs at most once.
 * `undo()` returns true when it cancels a still-pending send, false when it already fired (or
 * was already undone).
 *
 * @param {() => void} send
 * @param {{ delay?: number, onTick?: (secondsLeft: number) => void }} [options]
 * @returns {{ undo: () => boolean }}
 */
export function scheduleUndoableSend(send, { delay = UNDO_SEND_DELAY, onTick } = {}) {
  let secondsLeft = Math.ceil(delay / 1000);
  let settled = false;

  onTick?.(secondsLeft);

  const timer = setInterval(() => {
    secondsLeft -= 1;
    if (secondsLeft > 0) {
      onTick?.(secondsLeft);
      return;
    }
    settled = true;
    clearInterval(timer);
    send();
  }, 1000);

  const undo = () => {
    if (settled) return false;
    settled = true;
    clearInterval(timer);
    return true;
  };

  return { undo };
}
